import { render, staticRenderFns } from "./goodsBatchList.vue?vue&type=template&id=1eb5236a&scoped=true&"
import script from "./goodsBatchList.vue?vue&type=script&lang=js&"
export * from "./goodsBatchList.vue?vue&type=script&lang=js&"
import style0 from "./goodsBatchList.vue?vue&type=style&index=0&id=1eb5236a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb5236a",
  null
  
)

export default component.exports